let setLocalStorageVar = function(commit, val, commitKey, settingsKey) {
    commit(commitKey, val);

    //Save it to local storage for persistence throughout our session
    let advocateSettings = window.P2A.Helpers.LocalStorageLib.getJSON('p2a/adv/advocates');
    advocateSettings[settingsKey] = val;
    window.P2A.Helpers.LocalStorageLib.setLocalVar('p2a/adv/advocates', advocateSettings);
};

const mod = {
    namespaced: true,
    state: {
        showAdvocateTagsModal: false
    },
    mutations: {
        showAdvocateTagsModal: (state, showAdvocateTagsModal) => {
            state.showAdvocateTagsModal = showAdvocateTagsModal;
        }
    },
    getters: {
        showAdvocateTagsModal (state) {
            return state.showAdvocateTagsModal;
        }
    }
};

export default mod;
